
export default {
  // selectTotalSearchListAll: { // 통합검색 결과목록 전체 조회
  //   method: 'GET',
  //   url: 'mrm/v1/nrw/permit/student/searchsAll'
  // },
  selectTotalSearchList: { // 통합검색 결과목록 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/student/searchs'
  },
  selectSearchTotalKeyword: { // 추천검색어 조회
    method: 'GET',
    url: 'mrm/v1/permit/student/curations',
    showSpinner: false // 스피너 OFF
  },
  selectSearchAutoCourses: { // 자동완성과정 조회
    method: 'GET',
    url: 'mrm/v1/permit/student/search/autoCourses',
    showSpinner: false // 스피너 OFF
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/searchApi.js